// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3pk8x","rootSuccess":"CompleteLink_rootSuccess__32PDQ","rootFailure":"CompleteLink_rootFailure__3tfAU","isDisabled":"CompleteLink_isDisabled__3EL7T"};